import React from 'react';

interface TreeMapProps {
  latitude: number;
  longitude: number;
  treeNumber?: number;
  location?: string;
}

const TreeMap: React.FC<TreeMapProps> = ({ latitude, longitude, treeNumber, location }) => {

  
  // Get API key from environment variables
  const embedApiKey = process.env.REACT_APP_GOOGLE_MAPS_EMBED_API_KEY;
  
  // Don't render map if API key is not configured
  if (!embedApiKey) {
    console.warn('Google Maps Embed API key not configured');
    return null;
  }
  
  const mapSrc = `https://www.google.com/maps/embed/v1/place?key=${embedApiKey}&q=${latitude},${longitude}&zoom=15&maptype=satellite`;

  return (
    <div style={{ marginBottom: '1rem' }}>
      <div style={{ fontWeight: '600', color: '#666', fontSize: '0.9rem', marginBottom: '0.5rem' }}>
        {'Ubicación del Árbol'}
        {location && (
          <span style={{ fontWeight: '400', marginLeft: '0.5rem' }}>
            - {location}
          </span>
        )}
      </div>
      
      <div style={{
        borderRadius: '12px',
        overflow: 'hidden',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        background: '#f8f9fa',
        position: 'relative',
        width: '100%',
        maxWidth: '500px',
        aspectRatio: '16/9'
      }}>
        <iframe
          src={mapSrc}
          width="100%"
          height="100%"
          style={{ 
            border: 'none',
            display: 'block'
          }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title={`Tree ${treeNumber || ''} Location Map`}
        />
        
        
        {treeNumber && (
          <div style={{
            position: 'absolute',
            bottom: '8px',
            left: '8px',
            background: 'rgba(0,0,0,0.8)',
            color: 'white',
            padding: '6px 10px',
            borderRadius: '8px',
            fontSize: '0.8rem',
            fontWeight: '600',
            lineHeight: '1.2'
          }}>
            <div>🌳 {'Árbol'} {treeNumber}</div>
            <div style={{ fontSize: '0.7rem', opacity: '0.9', marginTop: '2px' }}>
              📍 {latitude.toFixed(4)}, {longitude.toFixed(4)}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TreeMap;